import React from "react";
import Footer from "../components/Footer";
import "./AboutBrand.css"; // Create a separate CSS file for styling
// import ProductButtons from "../components/ProductButtons"; // Подключаем кнопки
import BrandCards from "../components/BrandCards"; // Импортируем компонент
import { useState, useRef } from "react"; // <-- Добавь эти хуки в начало файла!
import { useLanguage } from "../i18n/LanguageContext";





function AboutBrand() {
  const { t } = useLanguage();
  const [isMuted, setIsMuted] = useState(true); // Управляем звуком
  const videoRef = useRef(null); // Получаем ссылку на видео

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(videoRef.current.muted);
    }
  };

  return (
    



    <div className="about-brand">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>VALMIS DE LUXE</h1>
          <p>{t("about.hero.subtitle")}</p>        
          </div>
      </section>

      {/* Achievements Section */}
      <section className="achievements">
  <div className="achievements-content">
    <h2>{t("about.achievements.title")}</h2>
          <ul>
            <li>{t("about.achievements.item1")}</li>
            <li>{t("about.achievements.item2")}</li>
            <li>{t("about.achievements.item3")}</li>
          </ul>
  </div>

    {/* Fish */}
    <div className="fish">
        <img src="/assets/fish_2.svg" alt="Decorative Fish" />
    </div>

  <div className="achievements-image">
    <img src="/assets/achievements-img.png" alt="Achievements" />
  </div>
</section>


        {/* Mission Section */}
        <section className="mission">
            <div className="mission-container">
                <div className="mission-left">
                    <h2>{t("about.mission.title")}</h2>
                <div className="mission-image">
                    <img src="/assets/mission-img.png" alt="Mission" />
                </div>
                </div>
                <div className="mission-text">
                <p>{t("about.mission.text")}</p>
                </div>
            </div>
        </section>



      
      {/* Products and Brands */}
      <section className="products-brands">
        <div className="products-brands-container">
            <div className="products-brands-text">
              
              <br className="products-brands-br"/>
              <br className="products-brands-br"/>
              <br className="products-brands-br"/>
              <h2 className="products-brands-title"> {t("about.products.title")}</h2>
            <strong>{t("about.products.subtitle")}</strong>
            <br />
                <p>{t("about.products.list")}</p>


                 <br/> 
                <strong className="products-brands-brandsTitle">{t("about.products.brands")}</strong>
            
                <BrandCards /> {/* Вставляем анимированные карточки брендов */}
                
            </div>

            <div className="products-brands-right">
                  <h2>{t("about.products.title")}</h2>
                <div className="products-brands-image">
                    <img src="/assets/products-brands-img-3.png" alt="Products and brands" />
                </div> 
            </div>
        </div>
       
      </section>

      {/* Video Section */}
        <section className="video-section">
          <div className="video-background">
            <video 
              ref={videoRef}
              id="promoVideo"
              className="video-player"
              loop
              autoPlay
              muted={isMuted} // Управляем звуком через state
              playsInline
              poster="/assets/video-background.jpg"
            >
              <source src="/assets/video.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            {/* Кнопка Mute/Unmute теперь внутри video-background */}
            <button className="mute-button" onClick={toggleMute}>
              {isMuted ? "🔊 " + t("about.video.unmuted") : "🔇 "+ t("about.video.muted")}
            </button>
          </div>

          <div className="video-content">
          <h2>{t("about.video.title")}</h2>
          <p>{t("about.video.subtitle")}</p>
          </div>
        </section>


          {/* Rosemary Background */}
          <div className="rosemary-wrapper">
            <div className="rosemary-bg"></div>
          </div>



      {/* Testimonials Section */}
          <section className="testimonials">
            {/* Заголовок по центру */}
            <div className="testimonials-header">
              <h2>{t("about.testimonials.title")}</h2>
            </div>

            {/* Контейнер с изображением и текстом */}
            <div className="testimonials-container">
              {/* Левая часть с изображением */}
              <div className="testimonials-left">
                <div className="testimonials-image">
                  <img src="/assets/testimonial.png" alt="Testimonial" />
                </div>
              </div>

              {/* Правая часть с текстом */}
              <div className="testimonials-text">
                <h3>{t("about.testimonials.subtitle")}</h3>
            <p>{t("about.testimonials.text1")}</p>
            <br />
            <p>{t("about.testimonials.text2")}</p>
              </div>
            </div>
          </section>



      {/* Advantages Section */}
      <section className="advantages">
      <div className="advantages-content">
        <h2>{t("about.advantages.title")}</h2>
          <ul>
            <li>{t("about.advantages.item1")}</li>
            <li>{t("about.advantages.item2")}</li>
            <li>{t("about.advantages.item3")}</li>
            <li>{t("about.advantages.item4")}</li>
          </ul>
      </div>

          <div className="advantages-image">
            <img src="/assets/advantages-img.png" alt="Advantages" />
          </div>

       </section>

        {/* Rosemary Background */}
        <div className="rosemary-wrapper-bottom">
                    <div className="rosemary-bg-bottom"></div>
                  </div>


      {/* Cooperation Message */}
      <section className="cooperation">
          <div className="cooperation-container">
          <div className="cooperation-left">
              <div className="mission-image">
                    <img src="/assets/cooperation-img.png" alt="Cooperation" />
              </div>
              </div>
              <div className="cooperation-text"> 
                            <p>{t("about.cooperation.text")}</p>
            </div>
            </div>
      </section>

      



      {/* Contact & Footer */}
      <Footer />
    </div>
  );
}

export default AboutBrand;
